<template>
  <div id="box" ref="box">
    <div id="left" v-show="tabShow" :style="{ width: detailWidth + 'px' }">
      <slot name="left"></slot>
    </div>
    <div v-show="tabShow" :id="'resize' + resizeId" class="resize"></div>
    <div id="right">
      <slot></slot>
    </div>
    <p></p>
  </div>
</template>

<script>
import uuid from "uuid/v1";
export default {
  props: {
    detailWidth: {
      type: Number,
      default: 260,
    //   default: 370,
    },
    resize: {
      type: Boolean,
      default: true,
    },
    tabShow:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      resizeId: uuid().replace(/-/g, ""),
    };
  },
  created() {
  },
  mounted() {
    if (this.resize == true) {
      this.dragControllerDiv();
    }
  },
  methods: {
    dragControllerDiv: function () {
      // 保留this引用
      let data = this;
      let resize = document.getElementById("resize" + this.resizeId);
      resize.onmousedown = function (e) {
        // 颜色改变提醒
        resize.style.background = "#818181";
        let startX = e.clientX;
        resize.left = resize.offsetLeft;
        document.onmousemove = function (e) {
          // 计算并应用位移量
          let endX = e.clientX;
          let moveLen = endX - startX;
          startX = endX;
          data.detailWidth += moveLen;
        };
        document.onmouseup = function () {
          // 颜色恢复
          resize.style.background = "";
          document.onmousemove = null;
          document.onmouseup = null;
        };
        return false;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
#box {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
}
#left {
  height: 100%;
  overflow: auto;
  background: #fff;
}

.resize {
  width: 14px;
  height: 100%;
  cursor: w-resize;
}

#right {
  height: 100%;
  flex: 1;
  overflow: auto;
}
</style>